import { render, staticRenderFns } from "./SalesArea.vue?vue&type=template&id=1b33b908"
import script from "./SalesArea.vue?vue&type=script&lang=js"
export * from "./SalesArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports